<script>
	import Welcome from './components/Welcome.svelte';
	import Tailwindcss from './Tailwindcss.svelte';
 	import { Router } from 'svelte-router-spa'
  	import { routes } from './routes'
	import UserObserver from './UserObserver.svelte';
	import { currentUser } from './stores/user.js';
	import { currentTenant } from './stores/tenant.js';
	import Login from './routes/login/Login.svelte';

	import Navigation from './layouts/Navigation.svelte';
	import MainToolbar from './layouts/MainToolbar.svelte';
	import LoadingScreen from './layouts/LoadingScreen.svelte';

	import './helper/UIHelper';
	import './helper/ImageCache';
  let sidebarOpen;


</script>
{#if $currentTenant != null && $currentUser != null}
<div class="h-screen flex overflow-hidden bg-gray-100">
  <!-- Off-canvas menu for mobile -->
  <div class="md:hidden">
    <div on:click={()=>{sidebarOpen = false}} class="fixed inset-0 z-30 bg-gray-600 opacity-0 pointer-events-none transition-opacity ease-linear duration-300" class:opacity-75={sidebarOpen} class:pointer-events-auto={sidebarOpen} class:opacity-0={!sidebarOpen} class:pointer-events-none-0={!sidebarOpen}></div>
    <div class="fixed inset-y-0 left-0 flex flex-col z-40 max-w-xs w-full bg-gray-800 transform ease-in-out duration-300 -translate-x-full" class:translate-x-0={sidebarOpen} class:-translate-x-full={!sidebarOpen}>
      <div class="absolute top-0 right-0 -mr-14 p-1">
	  	{#if sidebarOpen}
        <button on:click={()=>{sidebarOpen = false}} class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600">
          <svg class="h-6 w-6 text-white" stroke="currentColor" fill="none" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
		{/if}
      </div>
		<Navigation isMobile={true} />     
    </div>
  </div>

  <!-- Static sidebar for desktop -->
  <div class="hidden md:flex md:flex-shrink-0">
		<Navigation isMobile={false} />
  </div>
    
  <div class="flex flex-col w-0 flex-1 overflow-hidden">
    <div class="relative flex-shrink-0 flex h-16 bg-smfBlack-100 shadow">
      <button on:click={()=>{sidebarOpen = true}} class="px-4 border-r border-gray-200 text-gray-200 focus:outline-none focus:bg-gray-100 focus:text-gray-600 md:hidden">
        <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7" />
        </svg>
      </button>
	    <div class="flex-1 px-4 flex justify-between">
	  		<MainToolbar />
	  </div>
    </div>
    <main class="flex-1 relative z-0 overflow-y-auto py-6 focus:outline-none">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <h1 class="text-2xl font-semibold text-gray-900">Dashboard</h1>
      </div>

      <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <!-- Replace with your content -->
        <div class="py-4">
          <Router {routes} />
        </div>
        <!-- /End replace -->
      </div>
    </main>
  </div>
</div>
{:else if $currentTenant === null}
	<LoadingScreen/>
{:else}
	<Login />
{/if}

<UserObserver/>
<Tailwindcss/>


